import React, { useState, useEffect } from 'react';

import Skeleton from '@material-ui/lab/Skeleton';
import { useOpenCompetencyDrawer } from 'components/Develop/helpers/useOpenCompetencyDrawer';
import NewCardWithHeader from 'components/NewCardWithHeader';
import NoDataComponent from 'components/NoDataComponent';
import ScoreBar from 'components/ScoreBar';
import { useSelector, shallowEqual } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { FlexContainer, HiddenContentConditionCSS, StyledImage } from 'styles/common';

import { VIEW_ALL_COMPETENCY_ID, MISCELLANEOUS_COMPETENCY_ID } from 'constants/ProjectConstants';
import { getDevelopmentLevelColor, addAllToTeams, getCapitalizedTeams } from 'constants/helper';
import { WinnerCupIcon } from 'constants/icons';
import { sendViewedShared } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { getListV1 } from 'services/developments';

import { Typography13, Typography5 } from 'uiToolkit/Typography';

import EndorseComponent from './EndorseComponent';

function DevelopCard({ employee, showEndorseComponent = true, showHeader = true, includeMiscellaneous = false }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [hiddenContent, setHiddenContent] = useState(false);
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData, shallowEqual);

  let teams = employee.teams || [];
  teams = addAllToTeams(getCapitalizedTeams(employee.teams));
  const isEnterpriseUser = employee.isEnterpriseUser();
  const [selectedTeamId, setSelectedTeamId] = useState(null);

  const { openCompetencyPanel } = useOpenCompetencyDrawer();

  const handleStrengthClickPage = (tagId, tagTitle, description = '') => {
    sendViewedShared({
      eventProperties: {
        source: 'Profile',
      },
    });

    openCompetencyPanel({
      tagId,
      tagTitle,
      tagDescription: description,
      employeeId: employee?.id,
    });
  };
  useEffect(() => {
    if (!isEnterpriseUser && !selectedTeamId) return;
    setLoading(true);
    getListV1({
      employeeId: employee.id,
      teamId: isEnterpriseUser ? null : selectedTeamId,
      tagType: isEnterpriseUser ? 'CORE_COMPETENCIES' : 'LEADERBOARD',
      includeMiscellaneous,
    })
      .then((data) => {
        // if (employee.id == 2) setHiddenContent(true);
        setData(data);
      })
      .finally(() => setLoading(false));
  }, [employee.id, selectedTeamId]);

  useEffect(() => {
    if (!isEnterpriseUser) {
      const teamId = teams[0] ? teams[0].id : null;
      setSelectedTeamId(teamId);
    }
  }, [JSON.stringify(teams)]);

  return (
    <NewCardWithHeader
      displayBorder
      heading="Feedback"
      headerRightContent={
        <HeaderRightContainer>
          <Typography13
            color="primary"
            onClick={() => handleStrengthClickPage(VIEW_ALL_COMPETENCY_ID, 'View All', ' ')}
          >
            View All
          </Typography13>
        </HeaderRightContainer>
      }
      icon={<WinnerCupIcon size="tiny" color={theme.palette.icons.black2} />}
      showHeader={showHeader}
    >
      <div>
        {loading && <Skeleton variant="text" height="50%" />}
        {!loading &&
          data.length > 0 &&
          data.map((tag, index) => (
            <DevelopItem
              key={`profileDevelopCard${index}`}
              id={tag.id}
              employee={employee}
              hiddenContent={hiddenContent}
              index={index}
              name={tag.name}
              displayName={tag.displayName}
              stats={tag.stats}
              endorsers={tag.endorsers}
              imageUrl={tag.imageUrl}
              onStrengthClick={() => {
                let tagId = tag.id;
                if (tagId === null) tagId = MISCELLANEOUS_COMPETENCY_ID;

                handleStrengthClickPage(tagId, tag.displayName, tag.description);
              }}
              EndorseComponent={
                showEndorseComponent && loggedInEmployee.id !== employee.id ? (
                  <EndorseComponent isEnterpriseUser={isEnterpriseUser} employee={employee} tag={tag} />
                ) : null
              }
            />
          ))}
        {!loading && data.length === 0 && (
          <NoDataComponent
            height="20vh"
            message={
              isEnterpriseUser
                ? 'Core values and behaviors that are your strengths will be identified as you get recognized for them by others.'
                : 'Please complete your tasks and we will calculate your performance'
            }
          />
        )}
      </div>
    </NewCardWithHeader>
  );
}

function DevelopItem({
  employee,
  id,
  hiddenContent,
  index,
  name,
  displayName,
  stats = {},
  onStrengthClick,
  imageUrl,
  EndorseComponent,
}) {
  // const isEnterpriseUser = employee.isEnterpriseUser();
  const { score, level, count } = stats;
  return (
    <ItemContainer hiddenContent={index > 0 && hiddenContent}>
      <DetailsContainer>
        <IconAndName>
          {imageUrl && <StyledImage rightGutter={0.5} src={imageUrl} size="smallest" />}
          {/* {getStrengthIcon(displayName, { rightGutter: 0.5 })} */}
          <Typography5 style={{ overflowWrap: 'break-word', width: '100%' }} onClick={onStrengthClick}>
            {displayName}
          </Typography5>
          {/* {isEnterpriseUser && (
            <>
              <StyledTypography leftGutter={0.5} display="inline" color="textSecondary">
                ·
              </StyledTypography>
              <StyledTypography
                leftGutter={0.5}
                variant="body2"
                display="inline"
                color="textSecondary"
              >
                {score}%
              </StyledTypography>
            </>
          )} */}
        </IconAndName>
      </DetailsContainer>
      {id && (
        <StyledFlexContainer>
          <ScoreBar
            color={getDevelopmentLevelColor(level)}
            height="6px"
            width={EndorseComponent ? '95%' : '100%'}
            showBenchmark={false}
            score={score}
          />
          {EndorseComponent}
        </StyledFlexContainer>
      )}
    </ItemContainer>
  );
}

const ItemContainer = styled.div`
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  // border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  padding: ${(props) => props.theme.spacing(0.5)}rem 0;
  ${HiddenContentConditionCSS};
`;

const IconAndName = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DetailsContainer = styled(FlexContainer)`
  justify-content: space-between;
`;

const StyledFlexContainer = styled(FlexContainer)`
  justify-content: space-between;
  align-items: center;
  min-height: 28px;
`;

const HeaderRightContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default withRouter(DevelopCard);
